import {tokenizeQuery} from '@github-ui/filter-query'
import {Fragment} from 'react'

import styles from './SearchMatchText.module.css'

const MINIMUM_LENGTH_TO_HIGHLIGHT = 3
const SPECIAL_REGEX_CHARACTERS = /[.*+?^${}()|[\]\\]/g

export function SearchMatchText({query, children}: {query: string; children: string}) {
  const queryTextTokens = tokenizeQuery(query)
    .filter(segment => segment.type === 'text')
    .filter(segment => segment.value.length >= MINIMUM_LENGTH_TO_HIGHLIGHT)
    .map(segment => segment.value.toLowerCase())

  if (!queryTextTokens.length) return children

  const escapedTokens = queryTextTokens.map(token => token.replace(SPECIAL_REGEX_CHARACTERS, '\\$&'))
  const parts = children.split(new RegExp(`(${escapedTokens.join('|')})`, 'gi')).filter(part => !!part)

  return (
    <>
      {parts.map((part, index) =>
        queryTextTokens.includes(part.toLowerCase()) ? (
          // eslint-disable-next-line @eslint-react/no-array-index-key -- Part may be duplicated so we have no better key
          <span key={index} className={styles.highlightedText}>
            {part}
          </span>
        ) : (
          // eslint-disable-next-line @eslint-react/no-array-index-key
          <Fragment key={index}>{part}</Fragment>
        ),
      )}
    </>
  )
}

try{ SPECIAL_REGEX_CHARACTERS.displayName ||= 'SPECIAL_REGEX_CHARACTERS' } catch {}
try{ SearchMatchText.displayName ||= 'SearchMatchText' } catch {}